/* global axios */
import ApiClient from '../ApiClient';

// Link de convite de um agente que ainda não confirmou a conta (T-113). O administrador copia
// e entrega por outro canal quando o e-mail não chega.
class ConviteAPI extends ApiClient {
  constructor() {
    super('fandata/agents', { accountScoped: true });
  }

  gerar(agentId) {
    return axios.post(`${this.url}/${agentId}/convite`);
  }
}

export default new ConviteAPI();
